<mat-table
  [dataSource]="items"
  [trackBy]="trackBy"
  multiTemplateDataRows
  matSort
  matSortDisableClear
  [matSortActive]="sort"
  [matSortDirection]="sortDirection"
  (matSortChange)="onSortChange($event)"
>
  <ng-container matColumnDef="searchReason">
    <mat-header-cell *matHeaderCellDef>{{
      'alpr.export.columns.searchReason' | t
    }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <span class="text-truncate">{{ item.params.searchReason }}</span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="startedAt">
    <mat-header-cell *matHeaderCellDef mat-sort-header="startedAt">{{
      'alpr.export.columns.started' | t
    }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <span class="text-truncate">{{
        item.startedAt
          ? (item.startedAt | fsFormatDate : 'medium')
          : ('alpr.fallbacks.notAvailable' | t)
      }}</span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="completedAt">
    <mat-header-cell *matHeaderCellDef>{{ 'alpr.export.columns.finished' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <span class="text-truncate">{{
        item.completedAt
          ? (item.completedAt | fsFormatDate : 'medium')
          : ('alpr.fallbacks.notAvailable' | t)
      }}</span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="processingTime">
    <mat-header-cell *matHeaderCellDef>{{
      'alpr.export.columns.processingTime' | t
    }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <span class="text-truncate">{{
        getProcessingTimeInSeconds(item) | snDateDuration : true
      }}</span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="status">
    <mat-header-cell *matHeaderCellDef>{{ 'alpr.export.columns.status' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <fs-lpr-export-status [item]="item"></fs-lpr-export-status>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="expires">
    <mat-header-cell *matHeaderCellDef>{{ 'alpr.export.columns.expires' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <span class="text-truncate">{{ _calculateExpiresDate(item) | fsFormatDate : 'medium' }}</span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="fileSize">
    <mat-header-cell *matHeaderCellDef>{{ 'alpr.export.columns.fileSize' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <span class="text-truncate">{{
        item.fileSize ? (item.fileSize | snFilesize) : ('alpr.fallbacks.notAvailable' | t)
      }}</span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="actions">
    <mat-header-cell *matHeaderCellDef>{{ 'alpr.export.columns.actions' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <sn-action-list [items]="actions" [context]="item" alwaysExpand></sn-action-list>
    </mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
  <mat-row matRipple [@snFadeIn] [@snFadeOut] *matRowDef="let item; columns: columns"> </mat-row>
</mat-table>
